module.exports = __webpack_public_path__ + "static/media/woman-doing-virtual-shopping.dee3d4c8.gif";